// extracted by mini-css-extract-plugin
export default {"root":"_26BHn","content":"pLfYv"};